import {FC, useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {ErrorMessage, Field, Formik} from 'formik'

import { object } from 'yup'

type VPN=
  {
    [clave: string]: any
  }

type IntraOutbund={
  [clave: string]: any
}

type InterOutbund={
  [clave: string]: any
}

type EdgeOutbund={
  [clave: string]: any

}

export default function Step2(props:any) {

  //const [counter, setCounter] = useState(0)


  ///////////////////////////////////VPN Connector/////////////////////////////////////////
    //const [listVpnOutbund,setlistVpnOutbund]= useState <VPN>({})
    const items = [];
    let timeoutt:any


    const handleClick = (nombre:any, value:any) => {
      clearTimeout(timeoutt);  
      timeoutt = setTimeout(() => {
        //const list = listVpnOutbund;
        //let flag =false
        // Aquí puedes realizar la acción que desees después del retraso.
        console.log("Usuario ha terminado de escribir:", value);
       /* list.map((reg:any,i:any)=>{
          console.log(reg.nombre)
          console.log(nombre,'***')
  
          if (reg.nombre === nombre){
            flag= true
            console.log('hola')
            list[i].outbund = value
          }
          
       })
        if (flag){
          setlistVpnOutbund([...list])
        }
        else{
          setlistVpnOutbund([...list,{
            nombre:nombre,
            outbund:Number(value),
          }])

        }
      */
      props.setlistVpnOutbund({...props.listVpnOutbund,[nombre]:value})

      }, 100);
  
    
    }



    let contador =0
   if (props?.info){ for (const ej of props.info.listVPNcon){
      for (let i = 0; i < ej.Cantidad; i++) {
        let tempname= 'VPN-'+ ej.Connectcap+'-'+(String(items.length+1))
        items.push(
            <div className='fv-row' key={contador}>
              <div className='row'>
            <div className='col-lg-6'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'>Connector {items.length+1}</label> 
                <input 
                  type="text" 
                  name='cantidad ctx' 
                  className='form-control form-control-solid border-primary border-active'
                  value={ej.Connectcap + ' Mbps'}
                />  
            </div>
            <div className='col-lg-6'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'>Outbund (TB)</label> 
                <input 
                  type="number" 
                  value={props.listVpnOutbund[tempname as keyof typeof props.listVpnOutbund]}
                  name='cantidad Connector' 
                  className='form-control form-control-lg form-control-solid'
                  onChange={(e:any) => handleClick(tempname,e.target.value)}
                />
            </div>
            </div>  
          </div>    
       );
       contador++  
      }
    }}


    
  ////////////////////////////////Cloud Peering Connector INTRA Region//////////////////////////////////////////////////////
  //const[listIntraOutbund,setlistIntraOutbund]= useState<IntraOutbund>({})
  let timeout:any


  const handleClickIntra = (nombre:any, value:any) => {
    clearTimeout(timeout);

    
    timeout = setTimeout(() => {
      //const list = listIntraOutbund;
      //let flag =false
      // Aquí puedes realizar la acción que desees después del retraso.
      console.log("Usuario ha terminado de escribir:", value);
      /*list.map((reg:any,i:any)=>{
        console.log(reg.name)
        console.log(nombre,'***')

        if (reg.nombre === nombre){
          flag= true
          console.log('hola')
          list[i].outbund = value
        }
        
     })
      if (flag){
        setlistIntraOutbund([...list])
      }
      else{
        setlistIntraOutbund([...list,{
          nombre:nombre,
          outbund:Number(value),
        }])
      }*/
      props.setlistIntraOutbund({...props.listIntraOutbund,[nombre]:value})
    }, 100);

  }

  let contadorintra =1

  const itemsintra=[]
    if (props?.info){ for (const intra of props.info.listCloudConnIntra){
      let tempnameintra= 'CloudPeering-'+ intra.CapacidadIntra+'-'+intra.availability+'-'+(String(itemsintra.length+1))
        itemsintra.push(
            <div className='fv-row' key={contadorintra}>
              <div className='row'>
            <div className='col-lg-4'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'>Connector {contadorintra} </label> 
                <input 
                  type="text" 
                  name='cantidad ctx' 
                  className='form-control form-control-solid border-primary border-active'
                  value={intra.CapacidadIntra + ' Mbps'}
                />  
            </div>
            <div className='col-lg-4'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'>Region / Availability zone </label> 
                <input 
                  type="text" 
                  name='cantidad ctx' 
                  className='form-control form-control-solid border-primary border-active'
                  value={intra.RegionIntra +'/'+ intra.availability}
                />  
            </div>
            <div className='col-lg-4'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'>Outbund (TB) </label> 
                <input 
                  type="number" 
                  name='cantidad Connector' 
                  value={props.listIntraOutbund[tempnameintra as keyof typeof props.listIntraOutbund]}
                  className='form-control form-control-solid border-primary border-active'
                  onChange={(e:any) => handleClickIntra(tempnameintra,e.target.value)}
                />
            </div>
            </div>  
          </div>    
       );
       contadorintra++  
    }}


 

  
  ////////////////////////////////Cloud Peering Connector INTER Region//////////////////////////////////////////////////////
   // const[listInterOutbund,setlistInterOutbund]= useState<InterOutbund>({})
    
    let timeoutId:any
  
  

    const handleClickInter = (nombre:any, value:any) => {
      clearTimeout(timeoutId);

      
      timeoutId = setTimeout(() => {
       // const list = listInterOutbund;
        //let flag =false
        // Aquí puedes realizar la acción que desees después del retraso.
        console.log("Usuario ha terminado de escribir:", value);
        /*list.map((reg:any,i:any)=>{
          console.log(reg.name)
          console.log(nombre,'***')

          if (reg.nombre === nombre){
            flag= true
            console.log('hola')
            list[i].outbund = value
          }
          
       })
        if (flag){
          setlistInterOutbund([...list])
        }
        else{
          setlistInterOutbund([...list,{
            nombre:nombre,
            outbund:Number(value),
          }])
        }*/
        props.setlistInterOutbund({...props.listInterOutbund,[nombre]:value})
      }, 100);


   
    }

    const itemsinter=[]
    let contadoriner =1
    if (props?.info){ for (const inter of props.info.listCloudConnInter){
      let tempnameinter= 'CloudInter-'+ inter.CapacidadInterReg+'-'+inter.ZonaInter+'-'+(String(itemsinter.length+1))
        itemsinter.push(
            <div className='fv-row' key={contadoriner}>
              <div className='row'>
            <div className='col-lg-4'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'>Connector {contadoriner} </label> 
                <input 
                  type="text" 
                  name='cantidad ctx' 
                  className='form-control form-control-solid border-primary border-active'
                  value={inter.CapacidadInterReg + ' Mbps'}
                />  
            </div>
            <div className='col-lg-4'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'> Continent / Zone </label> 
                <input 
                  type="text" 
                  name='cantidad ctx' 
                  className='form-control form-control-solid border-primary border-active'
                  value={inter.ContinenteInterreg +'/'+ inter.ZonaInter}
                />  
            </div>
            <div className='col-lg-4'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'>Outbund (TB)</label> 
                <input 
                  type="number" 
                  name='cantidad Connector' 
                  value={props.listInterOutbund[tempnameinter as keyof typeof props.listInterOutbund]}
                  className='form-control form-control-solid border-primary border-active'
                  onChange={(e:any) => handleClickInter(tempnameinter,e.target.value)}
                />
            </div>
            </div>  
          </div>    
       );
       contadoriner++  
      }}
  

    
  ////////////////////////////////Edge Peering Connector //////////////////////////////////////////////////////


  //const [listEdgeOutbund,setlistEdgeOutbund]= useState<EdgeOutbund>({})
    const itemsEdge = [];
    let timeoutIdEdge:any

   

 
    const handleClickedge = (nombre:any, value:any) => {
      clearTimeout(timeoutIdEdge);

      
      timeoutIdEdge = setTimeout(() => {
        //const list = listEdgeOutbund;
        //let flag =false
        // Aquí puedes realizar la acción que desees después del retraso.
        console.log("Usuario ha terminado de escribir:", value);
        /*list.map((reg:any,i:any)=>{
          console.log(reg.name)
          console.log(nombre,'***')

          if (reg.nombre === nombre){
            flag= true
            console.log('hola')
            list[i].outbund = value
          }
          
       })
        if (flag){
          setlistEdgeOutbund([...list])
        }
        else{
        setlistEdgeOutbund([...list,{
          nombre:nombre,
          outbund:value,
        }])}*/
        
        props.setlistEdgeOutbund({...props.listEdgeOutbund,[nombre]:value})
      }, 100);


   
    }
    
   let contadorEdges =0
   if (props?.info){ for (const ej of props.info.listCEdgeConn){
      for (let i = 0; i < ej.cantidadedge; i++) {
        let tempnameEdge= 'Edge-'+ ej.capacidadedge+'-'+(String(itemsEdge.length+1))
        itemsEdge.push(
            <div className='fv-row' key={contadorEdges}>
              <div className='row'>
            <div className='col-lg-6'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'>Connector {i+1} </label> 
                <input 
                  type="text" 
                  name='cantidad ctx' 
                  className='form-control form-control-solid border-primary border-active'
                  value={ej.capacidadedge +' Mbps'}
                />  
            </div>
            <div className='col-lg-6'>
                <label className='form-label fs-6 fw-bolder text-dark required form-label'>Outbund (TB)</label> 
                <input 
                  type="number" 
                  name='cantidad Connector' 
                  value={props.listEdgeOutbund[tempnameEdge as keyof typeof props.listEdgeOutbund]}
                  className='form-control form-control-solid border-primary border-active'
                  onChange={(e:any) => handleClickedge(tempnameEdge,e.target.value)}
                />
            </div>
            </div>  
          </div>    
       );
       contadorEdges++  
      }
    }}

    useEffect( () => {
      let contadortemp=0
      const listed: number[]=[]

      /*for (const x of listEdgeOutbund){
       listed.push(Number(x.outbund))
       console.log(x.outbund)
      }*/
      const valoresEdge= Object.values(props.listEdgeOutbund)
      for (let edge of valoresEdge){
        const numeroedge= edge
        listed.push(Number(numeroedge))
      }
      /*for (const y of listVpnOutbund){
        listed.push(Number(y.outbund))
       }*/

      const valores= Object.values(props.listVpnOutbund)
      for (let x of valores){
        const numero = x
        listed.push(Number(numero))
      }

      const valoresIntra = Object.values(props.listIntraOutbund)
      for (let intra of valoresIntra){
        const numerointra= intra
        listed.push(Number(numerointra))
      }


      const valoresInter = Object.values(props.listInterOutbund)
      for(let inter of valoresInter){
        const numerointer= inter
        listed.push(Number(numerointer))
      }
      /*for (const z of listInterOutbund){
        listed.push(Number(z.outbund))
       }*/

      /*for (const w of listIntraOutbund){
        listed.push(Number(w.outbund))
       }*/
 


      // Calcular la suma de los valores en 'listed'

      contadortemp = listed.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      props.setCounter(contadortemp)

     
    }, [props.listEdgeOutbund,props.listVpnOutbund,props.listInterOutbund,props.listIntraOutbund])

    console.log (props.counter)


    /////////////////////////////////////
   
    

if(props?.info && props?.info.type_ctx !==''){
  return (
    <div className='w-100'>
      
    <div className='pb-10 pb-lg-15'>
        <h2 className='fw-bolder text-dark'>Your CTX plan is: {props.info.type_ctx}</h2>

        {(props.info.type_ctx ==='Connect'||props.info.type_ctx==='Protect') &&
        <div className='text-dark fw-bold fs-6'>
        For your <strong className='text-info'>{props.info.type_ctx} plan</strong>, you can enjoy as many terabytes (TB) as you need, <strong className='text-info'>within an outbound range of 10 TB to 100 TB</strong>, 
        which you can distribute among your pre-selected connectors.
        </div>}
        {props.info.type_ctx ==='Advanced' &&
        <div className='text-dark fw-bold fs-6'>
        For your <strong className='text-info'>{props.info.type_ctx} plan</strong>, you can enjoy as many terabytes (TB) as you need, <strong className='text-info'>within an outbound range of 10 TB to 400 TB</strong>, 
        which you can distribute among your pre-selected connectors.
        </div>}
    </div>
    { ( props.info.type_ctx ==='Connect' ||  props.info.type_ctx ==='Protect') && props.counter > 100 &&
    <div className='bg-light-danger p-10  fw-bolder fs-5 rounded text-center text-danger'>
        You have exceeded the Outbound TB limit of your plan, please reduce the amount in the connectors.
    </div>}
    {props.info.type_ctx ==='Advanced' && props.counter > 400 &&
    <div className='bg-light-danger p-10  fw-bolder fs-5 rounded text-center text-danger'>
        You have exceeded the Outbound TB limit of your plan, please reduce the amount in the connectors.
    </div>}
    <br />

    <div className='mb-10 fv-row'>
          <h1 className='form-label mb-3 text-center fs-5 fw-bolder'>TOTAL OUTBUND</h1>
          <Field type='text'
            className='form-control form-control-lg form-control-solid text-center bg-light-info text-info border-info'
            name='accountName'
            value= {props.counter}/>
           
        </div>

    {/*VPN Connector*/}
    <div className='mb-10 fv-row'>
      <div className='accordion' id='kt_accordion_1'>
          <div className='accordion-item'>
            <h2 className='accordion-header' id='kt_accordion_1_header_1'>
              <button
                className='accordion-button fs-4 fw-bold collapsed'
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#kt_accordion_1_body_1'
                aria-expanded='false'
                aria-controls='kt_accordion_1_body_1'
              >
                VPN Connectors
              </button>
            </h2>
            <div
              id='kt_accordion_1_body_1'
              className='accordion-collapse collapse'
              aria-labelledby='kt_accordion_1_header_1'
              data-bs-parent='#kt_accordion_1'
            >
              <div className='accordion-body'>
                {/******************************* */}
                <div className='fv-row'>
                  <div className='row'>
                    {items}
                  </div>
                </div>   
            </div>
          </div>
        </div>  
      </div>
    </div>

      {/*Cloud Peering Connector Intra*/}
  { itemsintra.length !==0 &&   <div className='mb-10 fv-row'>
      <div className='accordion' id='kt_accordion_2'>
          <div className='accordion-item'>
            <h2 className='accordion-header' id='kt_accordion_2_header_1'>
              <button
                className='accordion-button fs-4 fw-bold collapsed'
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#kt_accordion_2_body_1'
                aria-expanded='false'
                aria-controls='kt_accordion_2_body_1'
              >
                Cloud Peering Connector Intraregion
              </button>
            </h2>
            <div
              id='kt_accordion_2_body_1'
              className='accordion-collapse collapse'
              aria-labelledby='kt_accordion_2_header_1'
              data-bs-parent='#kt_accordion_2'
            >
              <div className='accordion-body'>
                {/******************************* */}
                <div className='fv-row'>
                  <div className='row'>
                    {itemsintra}
                  </div>
                </div>   
            </div>
          </div>
        </div>  
      </div>
    </div>}

 {/*Cloud Peering Connector Inter*/}
 { itemsinter.length!==0 &&<div className='mb-10 fv-row'>
      <div className='accordion' id='kt_accordion_3'>
          <div className='accordion-item'>
            <h2 className='accordion-header' id='kt_accordion_3_header_1'>
              <button
                className='accordion-button fs-4 fw-bold collapsed'
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#kt_accordion_3_body_1'
                aria-expanded='false'
                aria-controls='kt_accordion_3_body_1'
              >
                Cloud Peering Connector Inter Region
              </button>
            </h2>
            <div
              id='kt_accordion_3_body_1'
              className='accordion-collapse collapse'
              aria-labelledby='kt_accordion_3_header_1'
              data-bs-parent='#kt_accordion_3'
            >
              <div className='accordion-body'>
                {/******************************* */}
                <div className='fv-row'>
                  <div className='row'>
                    {itemsinter}
                  </div>
                </div>   
            </div>
          </div>
        </div>  
      </div>
    </div>}

    {/*Edge Peering Connector*/}
  {itemsEdge.length!==0 &&<div className='mb-10 fv-row'>
        <div className='accordion' id='kt_accordion_4'>
            <div className='accordion-item'>
              <h2 className='accordion-header' id='kt_accordion_4_header_1'>
                <button
                  className='accordion-button fs-4 fw-bold collapsed'
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target='#kt_accordion_4_body_1'
                  aria-expanded='false'
                  aria-controls='kt_accordion_4_body_1'
                >
                  Edge Peering Connector 
                </button>
              </h2>
              <div
                id='kt_accordion_4_body_1'
                className='accordion-collapse collapse'
                aria-labelledby='kt_accordion_4_header_1'
                data-bs-parent='#kt_accordion_4'
              >
                <div className='accordion-body'>
                  {/******************************* */}
                  <div className='fv-row'>
                    <div className='row'>
                      {itemsEdge}
                    </div>
                  </div>   
              </div>
            </div>
          </div>  
        </div>
      </div>}
      
        
    </div>
  )
}
else{
  return(<div className='text-center text-info fw-bolder fs-4'>Please Complete Previous Step</div>)
}}


